import React from 'react';
import { Polygon, Popup } from 'react-leaflet';
import type { Polygone } from '../../types/map';

interface MapPolygonsProps {
  polygones: Polygone[];
}

export const MapPolygons: React.FC<MapPolygonsProps> = ({ polygones }) => {
  return (
    <>
      {polygones.map((polygone: Polygone) => {
        if (!polygone || !polygone.coordonnees || !Array.isArray(polygone.coordonnees.coordinates)) {
          return null;
        }

        // Convert GeoJSON [lng, lat] to Leaflet [lat, lng]
        const leafletCoordinates = polygone.coordonnees.coordinates.map(ring =>
          ring.map(coord => [coord[1], coord[0]] as [number, number])
        );

        return (
          <Polygon
            key={polygone.id}
            positions={leafletCoordinates}
            pathOptions={{
              color: polygone.style?.couleurBordure || '#4CAF50',
              fillColor: polygone.style?.couleurFond || 'rgba(76, 175, 80, 0.3)',
              weight: polygone.style?.largeurBordure || 2,
              fillOpacity: polygone.style?.opaciteFond ?? 0.4
            }}
          >
            <Popup>
              <div className="popup-content">
                <h4>{polygone.titre || polygone.nom}</h4>
                {polygone.description && <p>{polygone.description}</p>}
                <div className="popup-meta">
                  <span className="category">{polygone.categorie}</span>
                  <span className="type">Polygone</span>
                </div>
                {polygone.style && (
                  <div className="popup-style">
                    <small>
                      Bordure: {polygone.style.couleurBordure} • 
                      Fond: {polygone.style.couleurFond} • 
                      Épaisseur: {polygone.style.largeurBordure}px
                    </small>
                  </div>
                )}
              </div>
            </Popup>
          </Polygon>
        );
      })}
    </>
  );
};
